export default __webpack_public_path__ + "a392bf6c447cbce3cdbcae4726b9b992.png";